import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { CounterIcon } from '@wf-common/atoms'

import styles from './counter-element.module.css'

const propTypes = {
    badgeClassName: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    count: PropTypes.number,
    testClassNamePostfix: PropTypes.string
}

const defaultProps = {
    count: 0,
    testClassNamePostfix: ''
}

/**
 * Small wrapper around the CounterIcon component to show a counter badge.
 *
 * @param {object} props                             - The React properties object.
 * @param {string} [props.className]                 - The additional tab className string
 * @param {string} [props.testClassNamePostfix='']   - A class name postfix for tests only.
 * @param {array|string} [props.children]            - Optional children to be rendered
 * @param {number} [props.count=0]                   - The number to be shown
 * @return {ReactElement} the counter icon.
 */
function CounterElement(props) {
    const { badgeClassName, children, className, count, testClassNamePostfix } = props
    if (!count) {
        return children || null
    }
    const testClassName = ['t3sel-counter-element', testClassNamePostfix].filter(Boolean).join('-')
    const badgeClassNameCombined = cx(styles['badge'], badgeClassName)
    return (
        <CounterIcon badgeClassName={badgeClassNameCombined} className={cx(className, testClassName)} iconCount={count}>
            {children}
        </CounterIcon>
    )
}

CounterElement.propTypes = propTypes
CounterElement.defaultProps = defaultProps

export default CounterElement
